import { atomWithStorage } from 'jotai/utils';
// 收藏的剧本：兼容旧数据（string id）与新数据（对象快照）
export const favoriteScriptsAtom = atomWithStorage('favorite_scripts', []);
